export default {"src":"/_next/static/media/Done.b9f65279.gif","height":1200,"width":1200,"blurWidth":0,"blurHeight":0};